import React from "react";

const Annotation = ({ value }) => (
  <div className="rn-annotation-wrap">{value}</div>
);

export default Annotation;
